<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)" [loading]="loading">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{col.field+'Column'}}" *ngFor="let col of columns" [ngStyle]="{'width': col.width ,'display': col.display}"
        [pSortableColumn]="col.field==isLab ? col.sort:col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field==isLab ? col.sort:col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td *ngIf="col.field!=isActive && col.field != isLab && col.field != isFormat && col.field != isBarcodeValidationRequired && col.field != isBarcodeExistOnBag
          && col.field != isCategoryType && col.field != isDefaultPriority && col.field != isAllowedPCRKits && col.field != isAllowedExtractorKits && col.field != isAllowedCyclerTypes
          && col.field != isAllowedExtractorTypes" class="wrapword">
          {{rowData[col.field]}}
        </td>
        <td *ngIf="col.field == isActive || col.field == isBarcodeValidationRequired || col.field == isBarcodeExistOnBag ">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="col.field==isLab">
          {{rowData[col.field]!= null? rowData[col.field].name :''}}
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div style="text-align:left">
      <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" style="height: 35px;" label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{popupTitle}} Details" [(visible)]="displayMasterListDialog" [focusOnShow]="false" showEffect="fade"
  [modal]="true" [style.width]="'800px'" position="top" [baseZIndex]="10000">
  <div *ngIf="masterList">
    <div *ngFor="let col of tableCols">
      <div class="form-group m-2">
        <div *ngIf="col.field!=isDefaultLanguage">
          <label>{{col.header}}</label>
        </div>
        <div *ngIf="col.field == isSenderName">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>
        <div *ngIf="col.field == isSenderShortName">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>
        <div *ngIf="col.field == isSenderGroupName">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>
        <div *ngIf="col.field == isLab">
          <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" [filter]="true" placeholder="Select a Lab"
            optionLabel="name" [showClear]="true"></p-dropdown>
        </div>
        <div *ngIf="col.field == isBarcodeFormat">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>
        <div *ngIf="col.field == isTrfBarcode">
          <p-dropdown [options]="trfBarcode" [(ngModel)]="masterList.trfBarcode" [filter]="true" placeholder="Select a TrfBarcode"
             [showClear]="true"></p-dropdown>
        </div>
        <div *ngIf="col.field == isTrfFormat">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>
        <div *ngIf="col.field == isBoxBarcode">
          <p-dropdown [options]="boxBarcode" [(ngModel)]="masterList[col.field]" [filter]="true" placeholder="Select a Box Barcode"
             [showClear]="true"></p-dropdown>
        </div>
        <div *ngIf="col.field == isBoxBarcodeFormat">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>
        <div *ngIf="col.field == isExternalSampleBarcode">
          <p-dropdown [options]="externalSampleBarcode" [(ngModel)]="masterList.externalSampleBarcode" [filter]="true" placeholder="Select External Barcode"
             [showClear]="true"></p-dropdown>
        </div>
        <div *ngIf="col.field == isRegionalCodes">
          <input pInputText class="form-control" [(ngModel)]="regionalCode">
            <div>(Comma seprated values of regional codes expected)</div>
        </div>
        <div *ngIf="col.field == isCheckForIdentity">
          <p-dropdown [options]="checkForIdentity" [(ngModel)]="masterList.checkForIdentity" [filter]="true" placeholder="Select a Identity"
             [showClear]="true"></p-dropdown>
        </div>

        <div *ngIf="col.field == isMergeGroup">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>

        <div *ngIf="col.field == isDataFormat">
          <p-dropdown [options]="dataFormatOptions" [(ngModel)]="masterList.dataFormat" [filter]="true" placeholder="Select a Data Format"
             [showClear]="true"></p-dropdown>
        </div>

        <div *ngIf="col.field == isDefaultPriority">
          <p-dropdown [options]="deafultPriorityList" [(ngModel)]="masterList[col.field]" placeholder="Select a Default Priority"></p-dropdown>
        </div>

        <div *ngIf="col.field == isAllowedPCRKits">
          <p-multiSelect [style]="{'width':'50%'}" [options]="allowedPCRKitsList" [(ngModel)]="masterList[col.field]" [filter]="true" placeholder="Select Allowed PCR Kits">
          </p-multiSelect>
        </div>

        <div *ngIf="col.field == isAllowedExtractorKits">
          <p-multiSelect [style]="{'width':'50%'}" [options]="allowedExtractorKitsList" [(ngModel)]="masterList[col.field]" [filter]="true" placeholder="Select Allowed Extractor Kits">
          </p-multiSelect>
        </div>

        <div *ngIf="col.field == isAllowedCyclerTypes">
          <p-multiSelect [style]="{'width':'50%'}" [options]="allowedCyclerManufacturerList" [(ngModel)]="masterList[col.field]" placeholder="Select Allowed Cycler Types">
          </p-multiSelect>
        </div>

        <div *ngIf="col.field == isAllowedExtractorTypes">
          <p-multiSelect [style]="{'width':'50%'}" [options]="allowedExtractorManufacturerList" [(ngModel)]="masterList[col.field]" placeholder="Select Allowed Extractor Types">
          </p-multiSelect>
        </div>

        <div *ngIf="col.field == isContactID">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>

        <div *ngIf="col.field == isActive || col.field == isBarcodeValidationRequired || col.field == isBarcodeExistOnBag ">
          <p-checkbox id="active" [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>
        <div *ngIf="col.field == isSwabType">
          <p-dropdown [options]="swabTypeList" [(ngModel)]="masterList[col.field]"></p-dropdown>
        </div>
        <div *ngIf="col.field == isStorageTime">
          <p-spinner size="3" [(ngModel)]="masterList[col.field]" [min]="1"></p-spinner>
        </div>
        <div *ngIf="col.field == isCategoryType">
          <p-multiSelect [options]="problemOptions" [(ngModel)]="selectedCategory" [filter]="true"
            placeholder="Select Problem Categories" [style]="{'width':'430px'}" optionLabel="categoryName">
          </p-multiSelect>
        </div>

      </div>
    </div>
  </div>

  <div class="ui-dialog-buttonpane ui-helper-clearfix">
    <button type="button" pButton icon="pi pi-check" [disabled]="isSaveDisabled()" (click)="saveMasterList()"
      label="Save" class="saveButton"></button>
  </div>

</p-dialog>
